/* Sydney Mirrors — Collection Grid V2
   - facet form submits via the Section Rendering API (no full page reload)
   - filter drawer on <1024px
   - "Load more" that appends the next paginated page
   - wishlist toggle (localStorage) + quick add to cart (/cart/add.js)

   Impulse wiring: after a successful add we dispatch `ajaxProduct:added`, which
   theme.js listens for to rebuild and open the cart drawer (assets/theme.js).
*/
(function () {
  var ROOT_SEL = '[data-sm-root]';

  function root() { return document.querySelector(ROOT_SEL); }

  /* ---------- Section rendering ---------- */
  function fetchSection(url, el) {
    var section = el.dataset.smSectionId;
    var u = new URL(url, window.location.origin);
    u.searchParams.set('section_id', section);
    el.setAttribute('data-sm-loading', '');
    return fetch(u.toString())
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var next = doc.querySelector(ROOT_SEL);
        if (!next) return;
        var facetState = readFacetState(el);
        ['[data-sm-results]', '[data-sm-facets-inner]', '[data-sm-pills]', '[data-sm-count]'].forEach(function (sel) {
          var a = el.querySelector(sel), b = next.querySelector(sel);
          if (a && b) a.innerHTML = b.innerHTML;
        });
        applyFacetState(el, facetState);
        var clean = new URL(url, window.location.origin);
        clean.searchParams.delete('section_id');
        window.history.replaceState({}, '', clean.toString());
        syncWishlist();
      })
      .finally(function () { el.removeAttribute('data-sm-loading'); });
  }

  function bindFacets(el) {
    var t;
    function submit() {
      var form = el.querySelector('[data-sm-facet-form]');
      if (!form) return;
      var params = new URLSearchParams(new FormData(form));
      // strip empties so the URL stays clean
      Array.from(params.keys()).forEach(function (k) {
        if (!params.get(k)) params.delete(k);
      });
      fetchSection(form.action.split('?')[0] + '?' + params.toString(), el);
    }
    // Delegated off the root so the handlers survive facet panel re-renders.
    el.addEventListener('input', function (e) {
      if (!e.target.closest('[data-sm-facet-form]')) return;
      if (e.target.type === 'number' || e.target.type === 'text') {
        clearTimeout(t); t = setTimeout(submit, 500);
      }
    });
    el.addEventListener('change', function (e) {
      if (!e.target.closest('[data-sm-facet-form]')) return;
      if (e.target.type === 'number' || e.target.type === 'text') return;
      submit();
    });
    el.addEventListener('submit', function (e) {
      if (!e.target.closest('[data-sm-facet-form]')) return;
      e.preventDefault(); submit(); closeDrawer(el);
    });
    // "Clear all" links re-render in place rather than doing a full page load.
    el.addEventListener('click', function (e) {
      var link = e.target.closest('[data-sm-clear]');
      if (!link) return;
      e.preventDefault();
      fetchSection(link.getAttribute('href'), el);
      closeDrawer(el);
    });
    // Active filter pills (remove one facet value).
    el.addEventListener('click', function (e) {
      var pill = e.target.closest('.sm-pill');
      if (!pill) return;
      e.preventDefault();
      fetchSection(pill.getAttribute('href'), el);
    });
  }

  /* Groups render collapsed unless they already hold a value, so a re-render
     would otherwise snap open groups shut mid-browse. Carry the open/closed
     state of each facet across the swap, keyed on its label. */
  function facetKey(details) {
    var label = details.querySelector('.sm-facet__btn span');
    return label ? label.textContent.trim() : '';
  }
  function readFacetState(el) {
    var state = {};
    el.querySelectorAll('.sm-facet').forEach(function (d) { state[facetKey(d)] = d.open; });
    return state;
  }
  function applyFacetState(el, state) {
    el.querySelectorAll('.sm-facet').forEach(function (d) {
      var k = facetKey(d);
      // An open group in the fresh markup means a filter is applied there — leave it.
      if (!d.open && state[k]) d.open = true;
    });
  }

  function bindSort(el) {
    el.addEventListener('change', function (e) {
      var sel = e.target.closest('[data-sm-sort]');
      if (!sel) return;
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      fetchSection(u.toString(), el);
    });
  }

  /* ---------- Load more ---------- */
  function bindLoadMore(el) {
    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-load-more]');
      if (!btn) return;
      var url = btn.dataset.smLoadMore;
      var section = el.dataset.smSectionId;
      var u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', section);
      btn.disabled = true;
      fetch(u.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var grid = el.querySelector('[data-sm-grid]');
          var nextGrid = doc.querySelector('[data-sm-grid]');
          if (grid && nextGrid) grid.insertAdjacentHTML('beforeend', nextGrid.innerHTML);
          var more = el.querySelector('[data-sm-more]');
          var nextMore = doc.querySelector('[data-sm-more]');
          if (more) more.innerHTML = nextMore ? nextMore.innerHTML : '';
          var count = el.querySelector('[data-sm-count]');
          if (count && count.dataset.smTemplate) {
            var shown = el.querySelectorAll('[data-sm-grid] > li').length;
            count.textContent = count.dataset.smTemplate
              .replace('@shown@', shown)
              .replace('@total@', count.dataset.smTotal);
          }
          syncWishlist();
        })
        .finally(function () { btn.disabled = false; });
    });
  }

  /* ---------- Drawer ---------- */
  function openDrawer(el) {
    var d = el.querySelector('[data-sm-facets]');
    if (!d) return;
    d.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeDrawer(el) {
    var d = el.querySelector('[data-sm-facets]');
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  function bindDrawer(el) {
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-sm-drawer-open]')) { openDrawer(el); return; }
      if (e.target.closest('[data-sm-drawer-close]')) { closeDrawer(el); return; }
      var facets = e.target.closest('[data-sm-facets]');
      if (facets && e.target === facets) closeDrawer(el);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(el); });
  }

  /* ---------- Wishlist (local only) ---------- */
  var WKEY = 'sm:wishlist';
  function wishlist() {
    try { return JSON.parse(localStorage.getItem(WKEY) || '[]'); } catch (e) { return []; }
  }
  function syncWishlist() {
    var list = wishlist();
    document.querySelectorAll('[data-sm-wish]').forEach(function (b) {
      b.setAttribute('aria-pressed', list.indexOf(b.dataset.smWish) > -1 ? 'true' : 'false');
    });
  }
  function bindWishlist(el) {
    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-wish]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var id = btn.dataset.smWish, list = wishlist(), i = list.indexOf(id);
      if (i > -1) list.splice(i, 1); else list.push(id);
      try { localStorage.setItem(WKEY, JSON.stringify(list)); } catch (err) {}
      syncWishlist();
    });
  }

  /* ---------- Quick add ---------- */
  function bindQuickAdd(el) {
    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sm-add]');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var id = btn.dataset.smAdd;
      if (!id) { window.location.href = btn.dataset.smUrl; return; }
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          // Same tick confirmation the homepage card uses.
          btn.classList.add('is-added');
          setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
          // Impulse: theme.js rebuilds the cart drawer and opens it on this event.
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data } }));
        })
        .finally(function () { btn.disabled = false; });
    });
  }

  function init() {
    var el = root();
    if (!el || el.dataset.smInit) return;
    el.dataset.smInit = '1';
    bindFacets(el); bindSort(el); bindLoadMore(el); bindDrawer(el);
    bindWishlist(el); bindQuickAdd(el); syncWishlist();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', function () {
    var el = root(); if (el) delete el.dataset.smInit;
    init();
  });
  init();
})();
